const { ccclass, property } = cc._decorator;

@ccclass
export default class ToggleObjectContral extends cc.Component {

    @property([cc.Node])
    activeTab: cc.Node[] = [];

    @property([cc.Node])
    deActiveTab: cc.Node[] = [];

    @property(cc.Toggle)
    _toggle: cc.Toggle = null;

    // LIFE-CYCLE CALLBACKS:

    onLoad() {
        if (this._toggle == null) {
            this._toggle = this.getComponent(cc.Toggle);
        }

       
        let self = this;
        this._toggle.node.on('toggle', function (event: cc.Toggle) {
            let toggle = event;

            //cc.warn(" toggle event .. ");
            for (let i = 0; i < self.activeTab.length; i++) {
                self.activeTab[i].active = toggle.isChecked;                
               
            }

            for (let i = 0; i < self.deActiveTab.length; i++) {
                self.deActiveTab[i].active = !toggle.isChecked;
               
            }

        }, this);
    }

    start() {

    }

    // update (dt) {}
}
